import { render, staticRenderFns } from "./ContentsDataTable.vue?vue&type=template&id=113e6b45&"
import script from "./ContentsDataTable.vue?vue&type=script&lang=js&"
export * from "./ContentsDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports